import React from 'react'
import styled from 'styled-components'
import {spacing} from 'lib/ui/theme'

type Props = {
  type: 'area' | 'room'
}

export default function InvalidDirectAccessLink(props: Props) {
  return (
    <Container>
      <Title aria-label="invalid direct access link">
        This link is no longer valid
      </Title>
      <Message>
        This direct {props.type} access link is invalid or has expired. Please
        contact the event organizer for an updated link.
      </Message>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: ${spacing[12]};
  text-align: center;
`

const Title = styled.h1`
  font-size: 1.75rem;
  font-weight: 600;
  margin: 0 0 ${spacing[4]};
`

const Message = styled.p`
  font-size: 1.125rem;
  max-width: 32rem;
  margin: 0;
  line-height: 1.5;
`
